(function () {
  const TARGET_HANDLES = [
    'true-color-restorer',
    'true-color-restorer-plus',
    'color-restorer-chelating-bundle',
    'color-restorer-plus-chelating-bundle',
    'beginners-bundle-true-color-restorer-chelating-shampo-african-shea-butter'
  ];

  const UPSELL_SELECTOR = '[data-cart-upsell]';
  const VISIBLE_CLASS = 'is-visible';

  function getUpsellEl() {
    return document.querySelector(UPSELL_SELECTOR);
  }

  function setVisible(visible) {
    const el = getUpsellEl();
    if (!el) return;
    el.classList.toggle(VISIBLE_CLASS, !!visible);
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
    return await res.json();
  }

  async function updateUpsell() {
    try {
      const el = getUpsellEl();
      if (!el) return;

      const cart = await fetchCart();
      const items = Array.isArray(cart.items) ? cart.items : [];
      const hasMatch = items.some(item => TARGET_HANDLES.includes(item.handle));
      setVisible(hasMatch);
    } catch (e) {
      // Fail closed (hidden) without breaking the theme
      setVisible(false);
    }
  }

  // Debounced scheduler so we can call this often without spamming
  let t = null;
  function scheduleUpdate(delay = 200) {
    clearTimeout(t);
    t = setTimeout(updateUpsell, delay);
  }

  // Short polling burst (reliable even when themes update asynchronously)
  function pollBurst() {
    let count = 0;
    const max = 8;          // ~8 checks
    const interval = 350;   // over ~2.8 seconds
    const id = setInterval(() => {
      scheduleUpdate(0);
      count += 1;
      if (count >= max) clearInterval(id);
    }, interval);
  }

  // 1) Catch common add-to-cart submits
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form) return;
    const action = (form.getAttribute('action') || '').toLowerCase();
    if (action.includes('/cart/add')) {
      scheduleUpdate(250);
      pollBurst();
    }
  }, true);

  // 2) Catch clicks that often trigger cart updates (themes vary)
  document.addEventListener('click', (e) => {
    const btn = e.target && e.target.closest
      ? e.target.closest('button, a, input[type="submit"]')
      : null;

    if (!btn) return;

    const name = (btn.getAttribute('name') || '').toLowerCase();
    const id = (btn.getAttribute('id') || '').toLowerCase();
    const href = (btn.getAttribute('href') || '').toLowerCase();

    // Heuristic triggers: add / plus / minus / remove in drawers
    if (
      name.includes('add') ||
      id.includes('add') ||
      id.includes('cart') ||
      href.includes('/cart')
    ) {
      scheduleUpdate(350);
      pollBurst();
    }
  }, true);

  // 3) Observe cart drawer DOM changes (when sections re-render)
  function attachDrawerObserver() {
    const possible = [
      '#CartDrawer',
      '#cart-drawer',
      '.cart-drawer',
      '[data-cart-drawer]',
      'cart-drawer'
    ];

    let drawer = null;
    for (const sel of possible) {
      drawer = document.querySelector(sel);
      if (drawer) break;
    }

    // If we can't find it now, observe body until it appears
    if (!drawer) {
      const bodyObserver = new MutationObserver(() => {
        for (const sel of possible) {
          drawer = document.querySelector(sel);
          if (drawer) break;
        }
        if (drawer) {
          bodyObserver.disconnect();
          attachObserverTo(drawer);
          scheduleUpdate(0);
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
      return;
    }

    attachObserverTo(drawer);
  }

  function attachObserverTo(node) {
    const obs = new MutationObserver(() => {
      // Drawer content replaced/updated → re-evaluate cart
      scheduleUpdate(150);
    });
    obs.observe(node, { childList: true, subtree: true });
  }

  // Init
  document.addEventListener('DOMContentLoaded', () => {
    // Initial state
    updateUpsell();
    // Watch drawer changes
    attachDrawerObserver();
  });
})();
